<template>
  <div class="modal-manager">
    <component v-for="(modal, index) in ModalStack" :key="index" :is="modal.type" :modal="modal" />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { ModalTypes } from "@/lib/utilities/enums";

export default {
  computed: {
    ...mapState({
      ModalStack: (state) => state.RightNavSection.ModalManager.stack,
    }),
  },
  components: {
    [ModalTypes.Confirmation]: () =>
      import("@/components/modals/ConfirmationModal"),
    [ModalTypes.Scheduler_CopySchedule]: () =>
      import(
        "@/components/pages/Users/scheduler/TeamSchedule/CopyScheduleModal"
      ),
    [ModalTypes.Scheduler_EditSchedule]: () =>
      import(
        "@/components/pages/Users/scheduler/TeamSchedule/EditScheduleModal"
      ),
    [ModalTypes.Scheduler_EditDefaultSchedule]: () =>
      import(
        "@/components/pages/Users/scheduler/Settings/EditDefaultScheduleModal"
      ),
    [ModalTypes.EditSisenseDashboard]: () =>
      import(
        "@/components/pages/SystemAdmin/SisenseManager/SisenseManagerEdit"
      ),
    [ModalTypes.ChangeOwnershipSisenseDashboard]: () =>
      import(
        "@/components/pages/SystemAdmin/SisenseManager/SisenseManagerChangeOwnership"
      ),
    [ModalTypes.SharedWithListSisenseDashboard]: () =>
      import(
        "@/components/pages/SystemAdmin/SisenseManager/SisenseManagerSharedWithList"
      ),
    [ModalTypes.MigrateFavoritesSisenseDashboard]: () => import("@/components/pages/SystemAdmin/SisenseManager/SisenseManagerMigrateFavorites"),
    [ModalTypes.EditTableauView]: () => import("@/components/pages/SystemAdmin/TableauManager/TableauViewEdit.vue"),
    [ModalTypes.MigrateFavoritesTableauView]: () => import("@/components/pages/SystemAdmin/TableauManager/TableauViewMigrateFavorites.vue")
  },
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/modals/shared/ModalManager.vue